import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { changePassword, setPageTitle } from '../../actions';
import { Page } from '../../components';
import Button from '../../components/widgets/Button';
import { getAuthState } from '../../selectors';
import './styles.scss';

class ChangePasswordPage extends React.Component {
  static propTypes = {
    changePassword: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      error: null,
    };
  }

  componentDidMount() {
    this.props.setPageTitle('Profile');
  }

  componentWillReceiveProps(nextProps) {
    this.setState({error: nextProps.auth.error});
  }

  handleSubmit = (e) => {
    if (!this.loginForm.checkValidity()) return;
    e.preventDefault();
    const currentPassword = this.currentPasswordInput.value;
    const newPassword = this.newPasswordInput.value;
    const newPassword2 = this.newPassword2Input.value;

    if (newPassword !== newPassword2) {
      this.setState({error: 'Password mismatch'});

      return false;
    }
    this.props.changePassword(currentPassword, newPassword);
    this.currentPasswordInput.value = '';
    this.newPasswordInput.value = '';
    this.newPassword2Input.value = '';
  }

  render() {
    return (
      <Page className="password-change-page">
        <h3>Change Password</h3>
        <form onSubmit={this.handleSubmit} ref={(elem) => this.loginForm = elem}>
          <input id="current_password"
                 name="current_password"
                 required="required"
                 ref={(elem) => this.currentPasswordInput = elem}
                 placeholder="Current Password"
                 type="password"/>
          <input id="new_password"
                 name="new_password"
                 required="required"
                 ref={(elem) => this.newPasswordInput = elem}
                 placeholder="New Password"
                 type="password"/>
          <input id="new_password_r"
                 name="new_password_r"
                 required="required"
                 ref={(elem) => this.newPassword2Input = elem}
                 placeholder="New Password (again)"
                 type="password"/>
          <div className="error-message">
            {this.state.error}
          </div>
          <div className="success-message">
            {this.state.error === false ? 'Password changed successfully.' : null}
          </div>
          <Button submit primary onClick={this.handleSubmit}>Change</Button>
        </form>
      </Page>
    );
  }
}

export default connect((state) => (
  {auth: getAuthState(state)}
), {changePassword, setPageTitle})(ChangePasswordPage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/ChangePasswordPage/index.js